import React from 'react';
import ErrorOutlineIcon from '../../icons/ErrorOutlineIcon';
import './styles.css';
export default function BandwidthWarning() {
  return /*#__PURE__*/React.createElement("div", {
    className: "bandwidth-warning__container"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorOutlineIcon, {
    fontSize: "large",
    className: "bandwidth-warning__icon"
  })), /*#__PURE__*/React.createElement("h3", {
    className: "bandwidth-warning__info"
  }, "Insufficient Bandwidth"));
}